import { beHttp } from './beHttp';

/**
 * Transcripción multimodal de historia clínica — endpoint en psiplatform-be
 * (`NoteTranscriptionModule`). La psicóloga puede cargar el registro de una
 * sesión por foto (nota manuscrita), archivo (PDF/DOC/DOCX) o audio (nota de
 * voz) en vez de tipearlo: en los tres casos el resultado es texto plano que
 * se pega en el mismo textarea de "Agregar registro" — no persiste nada por
 * sí solo, el guardado sigue siendo `apiCoreAdapter.updateSessionNote`.
 *
 * Va por `beHttp` como cualquier otra llamada de psiplatform-fe a
 * psiplatform-be: mismo Bearer de la sesión de la psicóloga.
 */
export interface NoteTranscriptionResult {
  text: string;
}

/** Foto (jpg/jpeg/png) o archivo de texto (pdf/doc/docx) → texto transcripto. */
export async function transcribeNoteDocument(file: File): Promise<NoteTranscriptionResult> {
  const form = new FormData();
  form.append('file', file);

  return beHttp.post<NoteTranscriptionResult>(
    '/api/psychologist/note-transcription/document',
    form,
    {
      errorMessage: 'No se pudo transcribir el archivo',
      showErrorToast: false, // el error se muestra inline en el editor de registro
    },
  );
}

/** Nota de voz grabada en la app → texto transcripto. */
export async function transcribeNoteAudio(blob: Blob, filename: string): Promise<NoteTranscriptionResult> {
  const form = new FormData();
  form.append('file', blob, filename);

  return beHttp.post<NoteTranscriptionResult>(
    '/api/psychologist/note-transcription/audio',
    form,
    {
      errorMessage: 'No se pudo transcribir el audio',
      showErrorToast: false,
    },
  );
}
